export default {
  title: "Помощь",
  subtitle:
    "Наши специалисты готовы помочь Вам с возникшей проблемой во время проведения выставки. Расскажите о своей проблеме:",
  exhibition: "Выставка",
  pavilion: "Павильон",
  stand: "Стенд",
  name: "ФИО",
  phone: "Телефон ",
  problemCategory: "Категория заявки",
  infoText: "Текст обращения",
  privatePolicy:
    "Настоящим я даю согласие на обработку моих персональных данных на указанных ниже ",
  privatePolicyLink: "условиях обработки персональных данных",
  submit: "Отправить",
  submitAgain: "Отправить новое",
  titleSuccess: "Обращение отправлено",
  subtitleSuccess:
    "В течении 15 минут с вами свяжется менеджер для уточнения запроса.",
  submitSuccess: "Оно будет рассмотрено сотрудниками Экспоцентра",
  titleExpired: "Спасибо за Ваши обращения.",
  subTitleExpired:
    "Данный сервис доступен только во время проведения выставки.",
  error: "Произшла ошибка, попробуйте повторить позже."
};
